import React, { useContext, useEffect, useState } from 'react'
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { styled, Grid, Box, CardActionArea, CardContent, Typography, CircularProgress, Backdrop } from '@mui/material';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { Context as FilterContext } from '../../context/FilterContext'
import { filterByTags } from '../../utils/utils';

const StyledCard = styled(Card)(({ theme }) => ({
    '&:hover': {
        opacity: 0.9, // Adjust the desired opacity value
    },
}));

const MobileMansory = ({ api, refresh, endRefresh }) => {
    const [mainProd, setMainProd] = useState(JSON.parse(localStorage.getItem("main_product")))

    const [loading, setLoading] = useState(true)

    const [chunk_left, setChunkLeft] = useState([])
    const [chunk_right, setChunkRight] = useState([])

    const { state } = useContext(FilterContext)

    useEffect(() => {
        window.addEventListener("beforeunload", alertUser);
        return () => {
            window.removeEventListener("beforeunload", alertUser);
        };
    }, []);

    const alertUser = (e) => {
        localStorage.removeItem("main_product")
    };

    const fetchSimilarProdsByFilters = (item_id, n_rec, filters) => {
        setLoading(true)

        api.recommend('similarity', '1', item_id, '{}', n_rec, function (preds) {
            //console.log(preds)

            let shuffled = preds
                .map(value => ({ value, sort: Math.random() }))
                .sort((a, b) => a.sort - b.sort)
                .map(({ value }) => value)

            setChunkLeft(shuffled.slice(0, Math.floor(shuffled.length / 2)))
            setChunkRight(shuffled.slice(Math.floor(shuffled.length / 2), shuffled.length))

            setLoading(false)
        })
    }

    const onChangeMainProd = (prod) => {
        const data = {
            id: prod.item_id,
            title: prod.name,
            image: prod.images[0],
            price: prod.price,
            url: prod.url,
            tags: prod.tags
        }

        //console.log('CHANGE MAIN PROD')

        localStorage.setItem("main_product", JSON.stringify(data))
        setMainProd(data)

        fetchSimilarProdsByFilters(prod.item_id, 100, state)
        window.scrollTo(50, 50);
    }

    useEffect(() => {
        const firstFetch = () => {
            if (typeof state === 'object' && mainProd !== undefined && api !== undefined) {
                let item_id = (mainProd.id).split('/').at(-1)

                fetchSimilarProdsByFilters(item_id, 100, state)

                //console.log('FIRST FETCH VISUAL RECCOMEND')
            }
        }

        firstFetch()
    }, [api])

    useEffect(() => {
        const refreshFetch = () => {
            if (typeof state === 'object' && mainProd !== undefined && api !== undefined && refresh === true) {
                let item_id = (mainProd.id).split('/').at(-1)

                fetchSimilarProdsByFilters(item_id, 100, state)
                //console.log('REFRESH')
            }
        }

        refreshFetch()
        endRefresh(false)
    }, [refresh])

    return (
        <div>
            {
                filterByTags(chunk_left, state).length > 1 && filterByTags(chunk_left, state).length > 1 && !loading ?
                    <Grid container spacing={1.5}>
                        <Grid item xs={12} sm={12}>
                            <StyledCard>
                                <CardActionArea onClick={() => { window.open(mainProd.url, "_blank", "noreferrer"); }}>
                                    <CardMedia
                                        component="img"
                                        image={mainProd.image}
                                    />
                                </CardActionArea>
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="div">
                                        {mainProd.title}
                                    </Typography>
                                    <Typography variant="h6" component="div">
                                        {mainProd.price}$
                                    </Typography>
                                </CardContent>
                            </StyledCard>
                        </Grid>
                        <Grid item xs={6} sm={6}>
                            <ResponsiveMasonry key={1} columnsCountBreakPoints={{ 750: 1, 900: 2, 1100: 2, 1400: 3 }}>
                                <Masonry
                                    columnsCount={5}
                                    gutter="20px"
                                    options={{
                                        columnWidth: 1
                                    }}
                                >
                                    {
                                        filterByTags(chunk_left, state).map((product, i) => (
                                            <StyledCard key={i}>
                                                <CardActionArea onClick={() => onChangeMainProd(product)}>
                                                    <CardMedia
                                                        component="img"
                                                        image={product.images[0]}
                                                    />
                                                </CardActionArea>
                                            </StyledCard>
                                        ))
                                    }
                                </Masonry>
                            </ResponsiveMasonry>
                        </Grid>
                        <Grid item xs={6} sm={6}>
                            <ResponsiveMasonry key={2} columnsCountBreakPoints={{ 750: 1, 900: 2, 1100: 2, 1400: 3 }}>
                                <Masonry
                                    columnsCount={5}
                                    gutter="20px"
                                    options={{
                                        columnWidth: 1
                                    }}
                                >
                                    {
                                        filterByTags(chunk_right, state).map((product, i) => (
                                            <StyledCard key={i}>
                                                <CardActionArea onClick={() => onChangeMainProd(product)}>
                                                    <CardMedia
                                                        component="img"
                                                        image={product.images[0]}
                                                    />
                                                </CardActionArea>
                                            </StyledCard>
                                        ))
                                    }
                                </Masonry>
                            </ResponsiveMasonry>
                        </Grid>
                    </Grid> : !loading ?
                        <Box
                            sx={{
                                height: '100%',
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                minHeight: '75vh',
                                backgroundColor: '#f5f5f5'
                            }}>
                            <Typography variant="h6" component="div">
                                No products found, please reduce the number of filters
                            </Typography>
                        </Box> : <div />

            }
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}

export default MobileMansory